app.directive('fancy', function(){
    return {
        restrict: 'C',
        link: function(scope, element, attr){
            element.fancybox();
        }
    };
});
